<template>
    <div class="">

        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
            <div class="columns">
                <div class="column is-12 is-12-tablet">
                    <ValidationProvider rules="required|email|min:8" v-slot="{ errors,valid }">
                    <b-field
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                        :message="errors">
                        <b-input v-model="form.email" placeholder="Email"
                                size="is-medium"
                                icon="account"
                                autocapitalize="off">
                        </b-input>

                    </b-field>
                    </ValidationProvider>
                </div>
            </div>
            <div class="columns">
                <div class="column is-12">
                    <ValidationProvider rules="required|min:8" v-slot="{ errors,valid }">
                    <b-field
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                        :message="errors">
                        <b-input v-model="form.password" placeholder="Password"
                                type="password"
                                size="is-medium"
                                icon="account"
                                password-reveal>
                        </b-input>
                    </b-field>
                    </ValidationProvider>
                    <p class="has-text-right">
                        <router-link class="has-text-underline" to="/lostpassword">Forgot password</router-link>
                    </p>
                </div>
            </div>
            <div class="w-100 is-flex is-justify-content-center">
                <b-button @click="submit" type="is-primary">LOG IN</b-button>
            </div>
        </ValidationObserver>
            <p class="mt-3">Don't have an account? <a href="/register">Sign up</a></p>

    </div>
</template>

<style scoped>

</style>

<script>
import axios from "axios"
import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';

setInteractionMode('eager')


export default {
    name: 'SignUp1',
    props: {
        to:Object
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            form: {
                email: "",
                password: ""
            }
        }
    },
    methods: {
        async submit() {

            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    //const el = document.querySelector(".v-messages.error--text:first-of-type");
                    //el.scrollIntoView(true);
                    //window.scrollBy(0, -150);
                    return;
                }
                await axios.get('/sanctum/csrf-cookie')
                await axios.post("/api/login", this.form).then(response => {
                    if(response.data.status == "ok"){
                        this.$store.commit("auth/SET_AUTHENTICATED", true)
                        this.$toast.success("You have been logged in successfully")
                        
                        axios.get("/api/profile").then(response => {
                          const profile = response.data
                          this.$store.commit("auth/SET_USER_PROFILE", profile);
                          if(profile.email) {
                            this.$store.commit("auth/SET_EMAIL", profile.email)
                          }
                          if(profile.completedstage2 === true){
                            this.$store.commit("auth/SET_PROFILE",2)
                          }
                          else if(profile.completedstage1=== true){
                            this.$store.commit("auth/SET_PROFILE",1)
                          }
                          if (this.$store.state.auth.previousPage) {
                                return this.$router.push(this.$store.state.auth.previousPage)
                            } else {
                                this.$router.push("/")
                            }
                        })
                        this.$store.commit("auth/MUST_LOGIN",false)
                        //this.$router.push("/account")
                        this.$gtag.config({
                            'user_id': this.$store.state.auth.user.id,
                        })
                    }
                    else{
                        this.$toast.error(response.data.error)
                    }

                })
                    .catch(() => {
                        this.$toast.error("We cannot find your credentials")
                    })
            })
        }
    }
}
</script>


